module.exports = __webpack_public_path__ + "img/7.cd9157a5.jpg";